import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { NavigationItemStyled } from './navigation-item.styles';
import { NavigationItemText } from './navigation-item-text';
export const NavigationItem = (props) => {
    const { highlight = false, children, isChild = false, isMobile = false, icon = null, dataGa, link, user, brand, enableMobileLoginIcon, } = props;
    return (_jsxs(NavigationItemStyled, { isChild: isChild, highlight: highlight, isMobile: isMobile, "data-ga": dataGa, "data-test": highlight ? 'promoted' : null, "data-testid": "navigation-item", children: [_jsx(NavigationItemText, { highlight,
                isMobile,
                brand,
                link,
                user,
                ...(!isMobile && { icon }),
                enableMobileLoginIcon,
                isChild }), children] }));
};
//# sourceMappingURL=navigation-item.js.map